import { useCallback } from "react";

import { getMatchingDOMNodes, waitForNextFrame } from "../utils/parser";
import { sumSectionMatchesCount } from "../utils/navigation";
import {
  highlightDOMMatches,
  findActiveMatchDOM,
  scrollToMatch,
} from "../utils/dom";

export const useTable = ({ openTableById }) => {
  const handleOpenTable = useCallback(
    async ({
      tableId,
      searchRegExp,
      matches,
      activeSectionIndex,
      activeGroupIndex,
      activeMatchIndex,
    }) => {
      const tableTitle = document.getElementById(tableId)?.innerText || "";

      openTableById(tableId, tableTitle);
      await waitForNextFrame(); // Let React render next frame with the dialog opened

      const dialogBody = document.querySelector("[role=dialog]");
      if (!dialogBody) {
        return;
      }

      const prevSectionGroups = matches[activeSectionIndex].slice(
        0,
        activeGroupIndex
      );
      const groupMatchesOffset = sumSectionMatchesCount(prevSectionGroups);
      const groupActiveMatchIndex = activeMatchIndex - groupMatchesOffset;

      const nodes = getMatchingDOMNodes(dialogBody, searchRegExp);
      highlightDOMMatches(searchRegExp, nodes, groupActiveMatchIndex);

      const activeMatchDOM = findActiveMatchDOM(dialogBody);
      const scrolledParent = dialogBody.parentNode?.parentNode; // [data-element="dialog-overlay"]
      scrollToMatch(activeMatchDOM, scrolledParent);
    },
    [openTableById]
  );

  return { handleOpenTable };
};
